import type { TransactionType } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export const isType =
    (...types: TransactionType[]): TransactionPredicate =>
    ({ txType }) =>
        Boolean(txType) && types.includes(txType);
